import { AbstractControl, UntypedFormGroup, ValidatorFn } from '@angular/forms';

export function sectionValidator(sectionForm: UntypedFormGroup): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const controls = sectionForm.controls;
    const errors = Object.keys(controls).reduce((obj, curr) => {
      if (controls[curr].touched && controls[curr].errors) {
        obj = { ...obj, ...controls[curr].errors, sectionError: true };
      }
      return obj;
    }, sectionForm.errors || {});
    return sectionForm.valid ? null : { ...errors, sectionInvalid: true };
  };
}
